export { AddHelpDeskPage } from './ui/add-help-desk-page';
export { AddResourcesPage } from './ui/add-resources-page';
export { HelpdeskContainer } from './ui/helpdesk-container';
export { default as HelpdeskContainerQuery } from './ui/helpdesk-container/__generated__/helpdeskContainerQuery.graphql';
export type { helpdeskContainerQuery } from './ui/helpdesk-container/__generated__/helpdeskContainerQuery.graphql';
